import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ArticleHeader } from "./RelatedArticles";
import styles from "./ArticlePreview.module.scss";
import Link from "next/link";
import { useRouterContext } from "../../../../context/RouterContext";
export const ArticlePreview: React.FC<{
  header: ArticleHeader;
  inngress?: string;
  slug: string;
}> = t0 => {
  const $ = _c(18);
  const {
    header,
    inngress,
    slug
  } = t0;
  const {
    articlesPagePath
  } = useRouterContext();
  let t1;
  if ($[0] !== articlesPagePath || $[1] !== slug) {
    t1 = [...articlesPagePath, slug];
    $[0] = articlesPagePath;
    $[1] = slug;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = `/${t1.join("/")}`;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      border: "none"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== header.published) {
    t4 = header.published && <div className={styles.article__meta}><span className="detailheader">{new Date(header.published).toLocaleDateString("NO-nb")}</span></div>;
    $[4] = header.published;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== header.title) {
    t5 = <h2>{header.title}</h2>;
    $[6] = header.title;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== inngress) {
    t6 = inngress && <p>{inngress}</p>;
    $[8] = inngress;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
    t7 = <li className={styles.article}>{t4}{t5}{t6}</li>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== slug || $[15] !== t2 || $[16] !== t7) {
    t8 = <Link key={slug} href={t2} style={t3}>{t7}</Link>;
    $[14] = slug;
    $[15] = t2;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};